import React, { useState } from 'react';
import * as Dati from '../../Dati';
import { FideTassiProduct, Trad } from '../../components';
import { IFideTassiProduct } from '../../form/FideTassi';

interface IFideTassiProductsTabProps {
    DurationTypes: Dati.TDictTipo;
    OnChange: (e: React.FormEvent<any> | string, valore?: any) => any;
    OnAddProduct: (product: IFideTassiProduct) => void;
    OnBlurRiordina:  () => void;
    OnChangeDurata: (e: React.FormEvent<any>) => any;
    OnChangeSommaGarantitaA: (e: React.FormEvent<any> | string, valore?: any) => void;
    OnChangeSommaGarantitaDa: (e: React.FormEvent<any> | string, valore?: any) => void;
    OnChangeTipoDurata: (e: React.FormEvent<any> | string, valore?: any) => void;
    Products: IFideTassiProduct[];
}  

export const FideTassiProductsTab: React.FC<IFideTassiProductsTabProps> = ({
    DurationTypes,
    Products,
    OnAddProduct,
    OnBlurRiordina,
    OnChange,
    OnChangeDurata,
    OnChangeSommaGarantitaA,
    OnChangeSommaGarantitaDa,
    OnChangeTipoDurata
}) => {
    const [activeTab, setActiveTab] = useState(0);

    let groupedProducts: IFideTassiProduct[][] = Products.reduce((total: any, current) => {
        let last = total[total.length - 1];
        if (!last || last[0].ID_TipoProdotto !== current.ID_TipoProdotto) {
            total.push([current]);
        } else {
            last.push(current);
        }
        return total;
    }, []);

    groupedProducts = groupedProducts.sort((a: IFideTassiProduct[], b: IFideTassiProduct[]) => 
        `${Trad.Trad(a[0].TipoRamo)} - ${Trad.Trad(a[0].TipoProdotto)}` < `${Trad.Trad(b[0].TipoRamo)} - ${Trad.Trad(b[0].TipoProdotto)}` ? -1 : 1
    );

    return (
        <div className="form-group kt-form login-form__group row">
            <div className="col-3">
                <div className="kt-portlet portlet-shadow">
                    <div className="kt-portlet__body">
                        <ul className="nav nav-tabs flex-column nav-tabs-line nav-tabs-line-warning border-bottom-0">
                            {groupedProducts.map((group: IFideTassiProduct[], i: number) => (
                                <li className="nav-item" key={i}>
                                    <a className={`nav-link${i == activeTab ? ' active' : ''}`} href="#" onClick={(e) => {e.preventDefault(); setActiveTab(i); }}>
                                        {Trad.Trad(group[0].TipoRamo)} - {Trad.Trad(group[0].TipoProdotto)}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
            <div className="col-9">
                <div className="kt-portlet portlet-shadow">
                    <div className="kt-portlet__body tab-content">
                        <FideTassiProduct
                            Data={groupedProducts[activeTab]}
                            DurationTypes={DurationTypes}
                            OnAddProduct={OnAddProduct}
                            OnBlurRiordina={OnBlurRiordina}
                            OnChange={OnChange}
                            OnChangeDurata={OnChangeDurata}
                            OnChangeSommaGarantitaA={OnChangeSommaGarantitaA}
                            OnChangeSommaGarantitaDa={OnChangeSommaGarantitaDa}
                            OnChangeTipoDurata={OnChangeTipoDurata}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/FideTassi/FideTassiProductsTab.tsx